// Find a setting, on Setup's first page (the setup audit's gap list): a rule by any of the words in its
// label, its help or its section, on the Setup pages this person opens. Choosing one opens its page with
// the row in view and marked a moment (RuleSection's findSetting).
import { useMemo, useState } from 'react';
import { canOpenIn, placesFor } from '../blueprint/places.ts';
import { findSettings, type RulePage } from './settings-model.ts';
import { findSetting } from './rule-data.ts';

export function FindSetting({ held }: { held: readonly string[] }) {
  const [q, setQ] = useState('');
  // each Setup page this person opens, by its rail name and its link, as the rail draws them
  const pages = useMemo(() => {
    const m = new Map<string, { label: string; href: string }>();
    const setup = placesFor(canOpenIn(held), held).find((p) => p.id === 'setup');
    for (const g of setup?.groups ?? [])
      for (const x of g.pages)
        m.set(x.view === 'settings' && x.part ? x.part : x.view, {
          label: x.label,
          href: `#/${x.view}${x.part ? `/${x.part}` : ''}`,
        });
    return m;
  }, [held]);
  const found = findSettings(q, (p: RulePage) => pages.has(p));
  const asked = q.trim().length > 1;
  return (
    <div className="bp-find" role="search">
      <label htmlFor="find-setting">Find a setting</label>
      <input
        id="find-setting"
        type="search"
        className="field"
        value={q}
        placeholder="A word or two, like overtime or reminder"
        onChange={(e) => setQ(e.target.value)}
      />
      {asked &&
        (found.length ? (
          <ul className="bp-found" aria-label="Settings found">
            {found.map((f) => {
              const at = pages.get(f.page)!;
              return (
                <li key={f.key}>
                  <a href={at.href} onClick={() => findSetting(f.key)}>
                    {f.label}
                  </a>
                  <span className="muted small">
                    {at.label} › {f.section}
                  </span>
                </li>
              );
            })}
          </ul>
        ) : (
          <p className="muted small" role="status">
            No setting has those words. Try one word.
          </p>
        ))}
    </div>
  );
}
